module.exports = __webpack_public_path__ + "img/rectangle.08fd79f0.svg";